// General helper functions

export function isEmpty(obj: object | null | undefined) {
  // Source: https://stackoverflow.com/questions/679915/how-do-i-test-for-an-empty-javascript-object
  // because Object.keys(new Date()).length === 0;
  // we have to do some additional check
  return (obj != null) // 👈 null and undefined check
  && Object.keys(obj).length === 0
  && Object.getPrototypeOf(obj) === Object.prototype;
}

export function roundToTwoDecimals(num: number) {
  return Number(num.toFixed(2));
}

export function floorToThreeDecimals(num: number) {
  return Math.floor(num * 1000) / 1000;
}
